import React, { useRef, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import Navigation from "../components/Navigation";
import HomeOverlay from "../components/HomeOverlay";
import Footer from "../components/Footer";
import { useScrolled } from "../hooks";
import "../styles/contact.css";

const SCROLL_THRESHOLD = 500;

// TODO: thay bằng URL Web App đã deploy (có đuôi /exec)
const SCRIPT_URL = "https://script.google.com/macros/s/AKfycbzjCykNnnExfKYLEPo3xG6KXMLR4oMGbUFTFuOVGmRQSCRgRc2s3lJUuDcB-Xtt3mSfFA/exec";

/* ============ SVG ICONS ============ */
const Icons = {
  gmail: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" aria-hidden="true">
      <path d="M12 23.403V23.39 10.389L11.88 10.3h-.01L9.14 8.28C7.47 7.04 5.09 7.1 3.61 8.56 2.62 9.54 2 10.9 2 12.41v3.602L12 23.403zM38 23.39v.013l10-7.391V12.41c0-1.49-.6-2.85-1.58-3.83-1.46-1.457-3.765-1.628-5.424-.403L38.12 10.3 38 10.389V23.39zM14 24.868l10.406 7.692c.353.261.836.261 1.189 0L36 24.868V11.867L25 20l-11-8.133V24.868zM38 25.889V41c0 .552.448 1 1 1h6.5c1.381 0 2.5-1.119 2.5-2.5V18.497L38 25.889zM12 25.889L2 18.497V39.5C2 40.881 3.119 42 4.5 42H11c.552 0 1-.448 1-1V25.889z" />
    </svg>
  ),
  linkedin: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19.039,19.043H16.078V14.4c0-1.106-.023-2.53-1.544-2.53-1.544,0-1.78,1.2-1.78,2.449v4.722H9.792V9.5h2.845v1.3h.039a3.12,3.12,0,0,1,2.808-1.542c3,0,3.556,1.975,3.556,4.546v5.238ZM6.447,8.194A1.72,1.72,0,1,1,8.168,6.473,1.719,1.719,0,0,1,6.447,8.194ZM7.932,19.043H4.963V9.5H7.932ZM20.521,2H3.476A1.458,1.458,0,0,0,2,3.441V20.559A1.458,1.458,0,0,0,3.476,22H20.518A1.463,1.463,0,0,0,22,20.559V3.441A1.464,1.464,0,0,0,20.518,2Z" />
    </svg>
  ),
  itch: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 245.371 220.736" aria-hidden="true">
      <path d="M31.99 1.365C21.287 7.72.2 31.945 0 38.298v10.516C0 62.144 12.46 73.86 23.773 73.86c13.584 0 24.902-11.258 24.903-24.62 0 13.362 10.93 24.62 24.515 24.62 13.586 0 24.165-11.258 24.165-24.62 0 13.362 11.622 24.62 25.207 24.62h.246c13.586 0 25.208-11.258 25.208-24.62 0 13.362 10.58 24.62 24.164 24.62 13.585 0 24.515-11.258 24.515-24.62 0 13.362 11.32 24.62 24.903 24.62 11.313 0 23.773-11.714 23.773-25.046V38.298c-.2-6.354-21.287-30.58-31.988-36.933C180.118.197 157.056-.005 122.685 0c-34.37.003-81.228.54-90.697 1.365zm65.194 66.217a28.025 28.025 0 0 1-4.78 6.155c-5.128 5.014-12.157 8.122-19.906 8.122a28.482 28.482 0 0 1-19.948-8.126c-1.858-1.82-3.27-3.766-4.563-6.032l-.006.004c-1.292 2.27-3.092 4.215-4.954 6.037a28.5 28.5 0 0 1-19.948 8.12c-.934 0-1.906-.258-2.692-.528-1.092 11.372-1.553 22.24-1.716 30.164l-.002.045c-.02 4.024-.04 7.333-.06 11.93.21 23.86-2.363 77.334 10.52 90.473 19.964 4.655 56.7 6.775 93.555 6.788h.006c36.854-.013 73.59-2.133 93.554-6.788 12.883-13.14 10.31-66.614 10.52-90.474-.022-4.596-.04-7.905-.06-11.93l-.003-.045c-.162-7.926-.623-18.793-1.715-30.165-.786.27-1.757.528-2.692.528a28.5 28.5 0 0 1-19.948-8.12c-1.862-1.822-3.662-3.766-4.955-6.037l-.006-.004c-1.294 2.266-2.705 4.213-4.563 6.032a28.48 28.48 0 0 1-19.947 8.125c-7.748 0-14.778-3.11-19.906-8.123a28.025 28.025 0 0 1-4.78-6.155 27.99 27.99 0 0 1-4.736 6.155 28.49 28.49 0 0 1-19.95 8.124c-.27 0-.54-.012-.81-.02h-.007c-.27.008-.54.02-.813.02a28.49 28.49 0 0 1-19.95-8.123 27.992 27.992 0 0 1-4.736-6.155zm-20.486 26.49l-.002.01h.015c8.113.017 15.32 0 24.25 9.746 7.028-.737 14.372-1.105 21.722-1.094h.006c7.35-.01 14.694.357 21.723 1.094 8.93-9.747 16.137-9.73 24.25-9.746h.014l-.002-.01c3.833 0 19.166 0 29.85 30.007L210 165.244c8.504 30.624-2.723 31.373-16.727 31.4-20.768-.773-32.267-15.855-32.267-30.935-11.496 1.884-24.907 2.826-38.318 2.827h-.006c-13.412 0-26.823-.943-38.318-2.827 0 15.08-11.5 30.162-32.267 30.935-14.004-.027-25.23-.775-16.726-31.4L46.85 124.08C57.534 94.073 72.867 94.073 76.7 94.073zm45.985 23.582v.006c-.02.02-21.863 20.08-25.79 27.215l14.304-.573v12.474c0 .584 5.74.346 11.486.08h.006c5.744.266 11.485.504 11.485-.08v-12.474l14.304.573c-3.928-7.135-25.79-27.215-25.79-27.215v-.006l-.003.002z" />
    </svg>
  ),
  github: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" aria-hidden="true">
      <path d="M216.5 362.5c-66-8-112.5-55.5-112.5-117 0-25 9-52 24-70-6.5-16.5-5.5-51.5 2-66 20-2.5 47 8 63 22.5 19-6 39-9 63.5-9s44.5 3 62.5 8.5c15.5-14 43-24.5 63-22 7 13.5 8 48.5 1.5 65.5 16 19 24.5 44.5 24.5 70.5 0 61.5-46.5 108-113.5 116.5 17 11 28.5 35 28.5 62.5l0 52C323 491.5 335.5 500 350.5 494 441 459.5 512 369 512 257 512 115.5 397 0 255.5 0S0 115.5 0 257c0 111 70.5 203 165.5 237.5 13.5 5 26.5-4 26.5-17.5l0-40c-7 3-16 5-24 5-33 0-52.5-18-66.5-51.5-5.5-13.5-11.5-21.5-23-23-6-.5-8-3-8-6 0-6 10-10.5 20-10.5 14.5 0 27 9 40 27.5 10 14.5 20.5 21 33 21s20.5-4.5 32-16c8.5-8.5 15-16 21-21z" />
    </svg>
  ),
  facebook: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M22.06,11.987a10.061,10.061,0,1,0-11.633,9.939V14.9H7.872V11.987h2.555V9.771a3.551,3.551,0,0,1,3.8-3.915,15.427,15.427,0,0,1,2.252.2V8.529H15.211a1.454,1.454,0,0,0-1.64,1.571v1.887h2.791L15.915,14.9H13.571v7.03A10.064,10.064,0,0,0,22.06,11.987Z" />
    </svg>
  ),
  zalo: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" aria-hidden="true">
      <path d="M 9 4 C 6.2504839 4 4 6.2504839 4 9 L 4 41 C 4 43.749516 6.2504839 46 9 46 L 41 46 C 43.749516 46 46 43.749516 46 41 L 46 9 C 46 6.2504839 43.749516 4 41 4 L 9 4 z M 9 6 L 15.580078 6 C 12.00899 9.7156859 10 14.518083 10 19.5 C 10 24.66 12.110156 29.599844 15.910156 33.339844 C 16.030156 33.549844 16.129922 34.579531 15.669922 35.769531 C 15.379922 36.519531 14.799687 37.499141 13.679688 37.869141 C 13.249688 38.009141 12.97 38.430859 13 38.880859 C 13.03 39.330859 13.360781 39.710781 13.800781 39.800781 C 16.670781 40.370781 18.529297 39.510078 20.029297 38.830078 C 21.379297 38.210078 22.270625 37.789609 23.640625 38.349609 C 26.440625 39.439609 29.42 40 32.5 40 C 36.593685 40 40.531459 39.000731 44 37.113281 L 44 41 C 44 42.668484 42.668484 44 41 44 L 9 44 C 7.3315161 44 6 42.668484 6 41 L 6 9 C 6 7.3315161 7.3315161 6 9 6 z M 33 15 C 33.55 15 34 15.45 34 16 L 34 25 C 34 25.55 33.55 26 33 26 C 32.45 26 32 25.55 32 25 L 32 16 C 32 15.45 32.45 15 33 15 z M 18 16 L 23 16 C 23.36 16 23.700859 16.199531 23.880859 16.519531 C 24.050859 16.829531 24.039609 17.219297 23.849609 17.529297 L 19.800781 24 L 23 24 C 23.55 24 24 24.45 24 25 C 24 25.55 23.55 26 23 26 L 18 26 C 17.64 26 17.299141 25.800469 17.119141 25.480469 C 16.949141 25.170469 16.960391 24.780703 17.150391 24.470703 L 21.199219 18 L 18 18 C 17.45 18 17 17.55 17 17 C 17 16.45 17.45 16 18 16 z M 27.5 19 C 28.11 19 28.679453 19.169219 29.189453 19.449219 C 29.369453 19.189219 29.65 19 30 19 C 30.55 19 31 19.45 31 20 L 31 25 C 31 25.55 30.55 26 30 26 C 29.65 26 29.369453 25.810781 29.189453 25.550781 C 28.679453 25.830781 28.11 26 27.5 26 C 25.57 26 24 24.43 24 22.5 C 24 20.57 25.57 19 27.5 19 z M 38.5 19 C 40.43 19 42 20.57 42 22.5 C 42 24.43 40.43 26 38.5 26 C 36.57 26 35 24.43 35 22.5 C 35 20.57 36.57 19 38.5 19 z" />
    </svg>
  ),
  arrow: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M7 17L17 7M9 7h8v8" />
    </svg>
  ),
};

/* ============ DATA ============ */

const contactIntro = {
  title: "Let's Build Something Together.",
  tagline: "Open to work, collaboration and game ideas.",
  bio: "Whether it's a full project, a prototype or just a conversation about game design — I'm always up for a chat.",
};

const contactLinks = [
  {
    icon: "gmail",
    label: "Gmail",
    value: "tthtung274@gmail.com",
    href: "https://mail.google.com/mail/?view=cm&fs=1&to=tthtung274@gmail.com",
  },
  {
    icon: "linkedin",
    label: "LinkedIn",
    value: "linkedin.com/in/tthtung274",
    href: "https://www.linkedin.com/in/tthtung274/",
  },
  {
    icon: "itch",
    label: "Itch.io",
    value: "tthtung274.itch.io",
    href: "https://tthtung274.itch.io/",
  },
  {
    icon: "github",
    label: "GitHub",
    value: "github.com/tthtung274",
    href: "https://github.com/tthtung274",
  },
  {
    icon: "facebook",
    label: "Facebook",
    value: "facebook.com/tthtung274",
    href: "https://facebook.com/tthtung274",
  },
  {
    icon: "zalo",
    label: "Zalo",
    value: "0385 183 923",
    href: "https://zalo.me/0385183923",
  },
];

/* ============ TOAST (portal ra document.body) ============ */

const ContactToast = ({ type = "success", title, description, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      if (onClose) onClose();
    }, 4000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const isSuccess = type === "success";

  const node = (
    <div className="contact-toast-wrap" role="status" aria-live="polite">
      <div className={`contact-toast contact-toast-${type}`}>
        <div className="contact-toast-icon">
          {isSuccess ? (
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
            </svg>
          )}
        </div>

        <div className="contact-toast-body">
          <p className="contact-toast-title">{title}</p>
          {description && <p className="contact-toast-desc">{description}</p>}
        </div>

        <button
          type="button"
          className="contact-toast-close"
          onClick={onClose}
          aria-label="Close"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );

  if (typeof document === "undefined") return node;
  return createPortal(node, document.body);
};

/* ============ MAIN PAGE ============ */

const ContactPage = () => {
  const scrolled = useScrolled(SCROLL_THRESHOLD);

  const introRef = useRef(null);
  const contactRef = useRef(null);

  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "Job Opportunity",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [toast, setToast] = useState(null); // { type, title, description }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (isSubmitting) {
      return;
    }

    // Chụp lại dữ liệu form trước khi reset
    const payload = new URLSearchParams({
      name: form.name.trim(),
      email: form.email.trim(),
      subject: form.subject,
      message: form.message.trim(),
      website: "", // honeypot luôn rỗng với người thật
    });

    // === OPTIMISTIC UI ===
    // Hiện toast + reset form + mở lại nút NGAY, không chờ backend
    setIsSubmitting(true);
    setForm({
      name: "",
      email: "",
      subject: "Job Opportunity",
      message: "",
    });
    setToast({
      type: "success",
      title: "Message sent successfully",
      description: "Thanks for reaching out\nI'll reply soon!",
    });
    setIsSubmitting(false);

    // === BACKEND XỬ LÝ NỀN (fire-and-forget) ===
    // Nếu lỗi mạng thì mới thay toast thành lỗi
    fetch(SCRIPT_URL, {
      method: "POST",
      mode: "no-cors",
      body: payload,
    }).catch(() => {
      setToast({
        type: "error",
        title: "Please try again",
        description: "Unable to submit. Check your connection and retry.",
      });
    });
  };

  useEffect(() => {
    const sections = [introRef, contactRef];
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -80px 0px" }
    );
    sections.forEach((ref) => {
      if (ref.current) observer.observe(ref.current);
    });
    return () => observer.disconnect();
  }, []);

  return (
    <main
      className={`about-main contact-main${scrolled ? " scrolled" : ""}`}
      role="main"
    >
      {toast && (
        <ContactToast
          type={toast.type}
          title={toast.title}
          description={toast.description}
          onClose={() => setToast(null)}
        />
      )}

      <HomeOverlay />
      <Navigation />

      {/* ========== 01. CONTACT INTRODUCTION ========== */}
      <section
        id="contact-intro"
        className="intro-section contact-intro-section"
        ref={introRef}
        aria-labelledby="contact-intro-heading"
      >
        <div className="container-1400">
          <div className="section-head">
            <span className="section-eyebrow">01 — Contact Introduction</span>
            <h1 id="contact-intro-heading" className="section-title">
              Get in touch
            </h1>
          </div>

          <div className="contact-intro-layout">
            <h2 className="contact-intro-title">{contactIntro.title}</h2>
            <div className="contact-intro-text">
              <p className="contact-intro-tagline">{contactIntro.tagline}</p>
              <p className="contact-intro-bio">{contactIntro.bio}</p>
            </div>
          </div>
        </div>
      </section>

      {/* ========== 02 + 03. CONTACT INFO + FORM ========== */}
      <section
        id="contact-info"
        className="contact-section"
        ref={contactRef}
        aria-labelledby="contact-info-heading"
      >
        <div className="container-1400">
          <div className="section-head">
            <span className="section-eyebrow">02 — Contact Information</span>
            <h2 id="contact-info-heading" className="section-title">
              Where to find me
            </h2>
          </div>

          <div className="contact-grid">
            {/* Trái: 6 social links */}
            <aside className="contact-info-col" aria-label="Contact information">
              <p className="contact-status">
                Available for work &amp; collaboration
              </p>

              <ul className="contact-links">
                {contactLinks.map((item, i) => (
                  <li key={i}>
                    <a
                      className="contact-link"
                      href={item.href}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="contact-link-icon">
                        {Icons[item.icon]}
                      </span>
                      <span className="contact-link-body">
                        <span className="contact-link-label">{item.label}</span>
                        <span className="contact-link-value">{item.value}</span>
                      </span>
                      <span className="contact-link-arrow">
                        {Icons.arrow}
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            </aside>

            {/* Phải: form */}
            <div className="contact-form-col">
              <div className="section-head contact-form-head">
                <span className="section-eyebrow">03 — Contact Form</span>
                <h2 className="section-title">Send Me a Message</h2>
              </div>

              <p className="contact-form-desc">
                Have a project or opportunity in mind? Leave me a message.
              </p>

              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="contact-form-row">
                  <label className="contact-field">
                    <span className="contact-field-label">Name</span>
                    <input
                      type="text"
                      name="name"
                      value={form.name}
                      onChange={handleChange}
                      required
                      autoComplete="name"
                    />
                  </label>

                  <label className="contact-field">
                    <span className="contact-field-label">Email</span>
                    <input
                      type="email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      required
                      autoComplete="email"
                    />
                  </label>
                </div>

                <label className="contact-field">
                  <span className="contact-field-label">Subject</span>
                  <select
                    name="subject"
                    value={form.subject}
                    onChange={handleChange}
                  >
                    <option>Job Opportunity</option>
                    <option>Collaboration</option>
                    <option>Game Idea</option>
                    <option>Other</option>
                  </select>
                </label>

                <label className="contact-field">
                  <span className="contact-field-label">Message</span>
                  <textarea
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    rows="5"
                    required
                  />
                </label>

                <button
                  type="submit"
                  className="contact-submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Send Message"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default ContactPage;